import { useCallback, useContext } from 'react'
import '../assets/css/Category.css'
import '../assets/css/Common.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import Subcategory from './Subcategory'
import CategoryDropdownContext from '../context/CategoryDropdownContext'
import { useNavigate } from 'react-router-dom'
import { cleanName } from '../services/CommonService'

function Category({categoryName, isDropdown, subcategories}) {
    const {dropdownName, setDropdownName, closeDropdown} = useContext(CategoryDropdownContext)
    const navigate = useNavigate()

    const openDropdown = useCallback(() => {
        setDropdownName(categoryName)
    }, [setDropdownName, categoryName])

    const filterArticlesByCategory = useCallback(() => {
        navigate('/' + cleanName(categoryName))
    }, [categoryName, navigate])

    const handleDropdownToggle = useCallback(() => {
        dropdownName === categoryName ? closeDropdown() : setDropdownName(categoryName)
        if (!isDropdown) filterArticlesByCategory()
    }, [dropdownName, categoryName, closeDropdown, setDropdownName, isDropdown, filterArticlesByCategory])

    return (
        <div className='flex-container category-and-optional-dropdown'>
            <div className="category flex-container" onMouseEnter={openDropdown} onClick={handleDropdownToggle}>
                <p>
                    { categoryName }
                </p>
                {isDropdown && 
                    <FontAwesomeIcon icon={faCaretDown}></FontAwesomeIcon>
                }
            </div>
            {isDropdown && dropdownName === categoryName && subcategories.length !== 0 &&
                <ul className='flex-container category-dropdown' onMouseLeave={closeDropdown}>
                    <Subcategory key={0} subcategoryName="Sve" categoryName={categoryName} />
                    {subcategories.map((subcategory) => {
                        return <Subcategory key={subcategory.id} subcategoryName={subcategory.name} categoryName={categoryName} />
                    })}
                </ul>
            }
        </div>
    )
}

Category.defaultProps = {
    isDropdown: true,
    subcategoryNames: []
}


export default Category